module.exports = __webpack_public_path__ + "img/weigui.dc0a918a.png";